<template>
    <v-layout >
        <v-flex xs12>
            <v-layout class="px-3" row wrap>
                <confirmation-header-text class="ml-2" icon="mdi-account-multiple"
                                          text="Marriage Details"/>
                <v-flex md3 xs6>
                    <list-item-detail
                        :sub_title="application_data.gender"
                        :title="$vuetify.lang.t('$vuetify.gender')"/>
                </v-flex>
                <v-flex md3 xs6>
                    <list-item-detail
                        :sub_title="application_data.full_name"
                        :title="$vuetify.lang.t('$vuetify.name') + ' of '+application_data.gender"/>
                </v-flex>
                <v-flex md3 xs6>
                    <list-item-detail :sub_title="application_data.full_address"
                                      :title="$vuetify.lang.t('$vuetify.address')+ ' of '+application_data.full_name"/>
                </v-flex>
                <v-flex md3 xs6>
                    <list-item-detail :sub_title="application_data.citizenship_number"
                                      :title="$vuetify.lang.t('$vuetify.citizenship_number')+ ' of '+application_data.full_name"/>
                </v-flex>

                <v-flex md3 xs6>
                    <list-item-detail :sub_title="application_data.dob"
                                      :title="'Date of birth (BS) of '+application_data.full_name"/>
                </v-flex>

                <v-flex md3 xs6>
                    <list-item-detail :sub_title="application_data.date_of_marriage"
                                      :title="$vuetify.lang.t('$vuetify.date_of_marriage')"/>
                </v-flex>
                <v-flex md3 xs6>
                    <list-item-detail :sub_title="application_data.place_of_marriage"
                                      :title="$vuetify.lang.t('$vuetify.place_of_marriage')"/>
                </v-flex>

            </v-layout>

        </v-flex>
    </v-layout>
</template>

<script>
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";
    import ListItemDetail from "../../ListItemDetail";
    import FileListItemDetail from "../../FileListItemDetail";


    export default {
        components: {ConfirmationHeaderText, ListItemDetail, FileListItemDetail},
        data: () => ({
            rules: {
                required: value => !!value || "Required.",
                citizenship_image: null
            },
        }),

        computed: {
            application_data() {
                return this.$store.state.VisaSingle.visa.extra.application_data;
            }
        },
    };
</script>

<style>
</style>
